import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoaderService } from './loader.service';

export abstract class AbstractResolver<T> implements Resolve<T> {

    protected constructor(private loaderService: LoaderService) {}

    public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<T> {
      this.loaderService.startLoad();
      return this.doResolve(route, state)
        .pipe(finalize(() => this.loaderService.stopLoad()));
    }

    protected abstract doResolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<T>;
}
